module.exports = __webpack_public_path__ + "static/17-e9c5ae8cb9413f35c0a935a9b0a4876a.jpg";